import { I375Form } from 'clickNgo/models/crud/forms'

import { externalFieldNames } from '../../config/common'
import { IContact } from '../../model/types'

export const mapContactModifiedValues = (
  modifiedValues: Array<keyof Partial<I375Form>>
): string[] =>
  modifiedValues.reduce<Array<keyof IContact>>((acc, key) => {
    if (externalFieldNames[key]) {
      acc.push(externalFieldNames[key] as keyof IContact)
    }
    return acc
  }, [])
